// Buzzer-style error sound for scan rejection feedback.
// Generated via Web Audio API so we don't ship any audio assets.
// ~0.5s, low pitch (220Hz square wave with light amplitude pulsing).

let _ctx = null;
let _lastPlayedAt = 0;

function getCtx() {
  if (typeof window === 'undefined') return null;
  if (_ctx) return _ctx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  try {
    _ctx = new Ctx();
  } catch (_e) {
    return null;
  }
  return _ctx;
}

/**
 * Plays a short ~0.5s low-pitched buzzer sound.
 * Throttled to once every 120ms to prevent overlapping during rapid scans.
 */
export function playErrorBuzz() {
  try {
    const ctx = getCtx();
    if (!ctx) return;

    // Some browsers suspend the context until a user gesture. Try resume.
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    const now = Date.now();
    if (now - _lastPlayedAt < 120) return;
    _lastPlayedAt = now;

    const t0 = ctx.currentTime;
    const duration = 0.5;

    const osc = ctx.createOscillator();
    osc.type = 'square';
    // Low buzzer pitch with a small downward sweep for a "rejected" feel.
    osc.frequency.setValueAtTime(240, t0);
    osc.frequency.linearRampToValueAtTime(180, t0 + duration);

    const gain = ctx.createGain();
    // Pulse the gain to give a "buzz" texture instead of a flat tone.
    gain.gain.setValueAtTime(0, t0);
    gain.gain.linearRampToValueAtTime(0.35, t0 + 0.02);
    gain.gain.setValueAtTime(0.35, t0 + 0.18);
    gain.gain.linearRampToValueAtTime(0.05, t0 + 0.22);
    gain.gain.linearRampToValueAtTime(0.35, t0 + 0.26);
    gain.gain.setValueAtTime(0.35, t0 + 0.42);
    gain.gain.linearRampToValueAtTime(0.0001, t0 + duration);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(t0);
    osc.stop(t0 + duration + 0.02);
  } catch (_e) {
    // Silent failure — never break user-facing flow on audio errors.
  }
}

/**
 * Wraps the sonner `toast` singleton so that every call to `toast.error(...)`
 * also plays the error buzzer. Safe to call multiple times — only patches once.
 */
// API error details (e.g. FastAPI 422 arrays) crash React if rendered raw — flatten to text.
function toToastText(msg) {
  if (msg == null || typeof msg !== 'object' || msg.$$typeof) return msg;
  const one = (m) => {
    if (m == null) return '';
    if (typeof m !== 'object') return String(m);
    const field = Array.isArray(m.loc) ? m.loc.filter((p) => p !== 'body').join('.') : '';
    const text = m.msg || m.message || m.detail;
    if (text) return field ? `${field}: ${typeof text === 'string' ? text : JSON.stringify(text)}` : (typeof text === 'string' ? text : JSON.stringify(text));
    try { return JSON.stringify(m); } catch (_e) { return 'Unexpected error'; }
  };
  return Array.isArray(msg) ? (msg.map(one).filter(Boolean).join('; ') || 'Request failed') : one(msg);
}

export function attachErrorSoundToToast(toast) {
  if (!toast || typeof toast.error !== 'function') return;
  if (toast.__errorSoundPatched) return;
  const originalError = toast.error.bind(toast);
  const patched = (msg, ...rest) => {
    playErrorBuzz();
    return originalError(toToastText(msg), ...rest);
  };
  // Preserve any helper props on toast.error (e.g. .promise) just in case.
  Object.keys(toast.error).forEach((k) => {
    try { patched[k] = toast.error[k]; } catch (_e) { /* ignore */ }
  });
  toast.error = patched;
  toast.__errorSoundPatched = true;
}
